import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@api/modules/auth.api";
import { useAuthStore } from "@stores/auth";

export const useLogout = () => {
    const navigate = useNavigate();
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const logout = async () => {
        setIsLoggingOut(true);
        try {
            await authApi.logout();
        } catch {
            /* even if the server call fails, drop the local session */
        } finally {
            useAuthStore.getState().clearAuth();
            setIsLoggingOut(false);
            navigate("/login", { replace: true });
        }
    };

    return { logout, isLoggingOut };
};
